const css = `@charset "UTF-8";
.calendar-filters {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.calendar-filters .filters-container {
  display: flex;
  gap: 12px;
  align-items: center;
}
.calendar-filters .filters-container .filter-label {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-color-secondary);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  width: 79px;
  cursor: default;
}
.calendar-filters .filters-container .filter-label.active {
  color: var(--accent);
  cursor: pointer;
}
.calendar-filters .filters-container .filter-label.active:hover {
  color: var(--accent-hover);
}
.calendar-filters .filters-container .filter-label i {
  font-size: var(--font-size-lg);
}
.calendar-filters .filters-container .filter-buttons {
  flex-wrap: wrap;
  display: flex;
  gap: 4px;
  align-items: center;
}
.calendar-filters .filters-container .filter-buttons .filter-item {
  position: relative;
  width: 180px;
  max-width: 180px;
  display: flex;
  align-items: center;
  /* Estilos específicos para AdaptiveSelect cuando se usa como filtro */
}
.calendar-filters .filters-container .filter-buttons .filter-item .p-multiselect-label.p-placeholder {
  display: none;
}
.calendar-filters .filters-container .filter-buttons .filter-item .filter-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: var(--font-size-lg);
  z-index: 1;
  pointer-events: none;
  color: var(--text-color-secondary);
}
.calendar-filters .filters-container .filter-buttons .filter-item .filter-icon.active {
  color: var(--accent-text);
}
.calendar-filters .filters-container .filter-buttons .filter-item .filter-branch-dot {
  position: absolute;
  left: 34px;
  top: 50%;
  transform: translateY(-50%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  z-index: 2;
  pointer-events: none;
  border: 1.5px solid var(--on-color-border);
}
.calendar-filters .filters-container .filter-buttons .filter-item .filter-text {
  position: absolute;
  left: 36px;
  top: 50%;
  transform: translateY(-50%);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  z-index: 1;
  pointer-events: none;
  color: var(--text-color-secondary);
  white-space: nowrap;
  max-width: calc(100% - 48px);
  overflow: hidden;
  text-overflow: ellipsis;
}
.calendar-filters .filters-container .filter-buttons .filter-item .filter-text.active {
  color: var(--accent-text);
}
.calendar-filters .filters-container .filter-buttons .filter-item.has-branch-dot .filter-text {
  left: 50px;
  max-width: calc(100% - 62px);
}
.calendar-filters .filters-container .filter-buttons .filter-item .filter-dropdown {
  width: 180px;
  min-width: 180px;
  height: 40px;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  border-radius: 6px;
  background-color: var(--surface-ground);
  border: 1px solid var(--surface-border);
  cursor: pointer;
  padding-left: 32px;
  transition: all 0.2s ease;
}
.calendar-filters .filters-container .filter-buttons .filter-item .filter-dropdown.active {
  background: var(--accent);
  border-color: var(--accent);
}
.calendar-filters .filters-container .filter-buttons .filter-item .filter-dropdown.active ~ .filter-icon,
.calendar-filters .filters-container .filter-buttons .filter-item .filter-dropdown.active ~ .filter-text {
  color: var(--accent-text);
}
.calendar-filters .filters-container .filter-buttons .filter-item .filter-dropdown.active:not(.p-disabled):hover {
  background: var(--accent-hover) !important;
  border-color: var(--accent-hover) !important;
}
.calendar-filters .filters-container .filter-buttons .filter-item .filter-dropdown:not(.active):hover {
  border-color: var(--surface-border);
  background: var(--surface-hover);
}
.calendar-filters .filters-container .filter-buttons .filter-item .filter-dropdown .p-dropdown-label {
  opacity: 0;
  padding: 0;
}
.calendar-filters .filters-container .filter-buttons .filter-item .filter-dropdown .p-dropdown-trigger {
  display: none;
}
.calendar-filters .filters-container .filter-buttons .filter-item .adaptive-select-trigger.is-filter {
  width: 180px;
  min-width: 180px;
  height: 40px;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  border-radius: 6px;
  background-color: var(--surface-ground);
  border: 1px solid var(--surface-border);
  cursor: pointer;
  padding-left: 32px;
  transition: all 0.2s ease;
}
.calendar-filters .filters-container .filter-buttons .filter-item .adaptive-select-trigger.is-filter.active {
  background: var(--accent);
  border-color: var(--accent);
}
.calendar-filters .filters-container .filter-buttons .filter-item .adaptive-select-trigger.is-filter.active:not(.disabled):hover {
  background: var(--accent-hover) !important;
  border-color: var(--accent-hover) !important;
}
.calendar-filters .filters-container .filter-buttons .filter-item .adaptive-select-trigger.is-filter:not(.active):hover {
  border-color: var(--surface-border);
  background: var(--surface-hover);
}

.filter-panel {
  margin-top: 4px !important;
  border-radius: 4px;
  border: 1px solid var(--surface-border);
  box-shadow: 0 2px 4px var(--shadow-2);
}
.filter-panel .p-dropdown-items {
  padding: 0;
}
.filter-panel .p-dropdown-item {
  padding: 8px 12px;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
}
.filter-panel .p-dropdown-item:hover {
  background-color: var(--surface-hover);
}
.filter-panel .p-dropdown-item.p-highlight {
  background-color: var(--accent-subtle) !important;
  color: var(--accent) !important;
}
.filter-panel .p-dropdown-filter-container {
  margin: 0;
  padding: 8px;
  border-bottom: 1px solid var(--surface-border);
}
.filter-panel .p-dropdown-filter-container .p-dropdown-filter {
  font-size: var(--font-size-base);
  padding: 4px 8px;
}
.filter-panel .p-dropdown-filter-container .p-dropdown-filter-icon {
  right: 16px;
  font-size: var(--font-size-base);
}
.filter-panel .p-dropdown,
.filter-panel .p-multiselect {
  min-width: 200px;
  border: 1px solid var(--surface-border);
  border-radius: 4px;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  background: var(--surface-raised);
}
.filter-panel .p-dropdown .p-dropdown-label,
.filter-panel .p-dropdown .p-multiselect-label,
.filter-panel .p-multiselect .p-dropdown-label,
.filter-panel .p-multiselect .p-multiselect-label {
  padding: 4px 8px;
}
.filter-panel .p-dropdown .p-dropdown-trigger,
.filter-panel .p-multiselect .p-dropdown-trigger {
  width: 16px;
}

.branch-select .p-dropdown,
.branch-select .p-multiselect,
.employee-select .p-dropdown,
.employee-select .p-multiselect,
.type-select .p-dropdown,
.type-select .p-multiselect {
  width: 100%;
}

@media (max-width: 768px) {
  .calendar-filters .filters-container .filter-buttons {
    justify-content: center;
  }
  .calendar-filters .filters-container .filter-buttons .filter-item {
    width: 173.5px;
    max-width: 173.5px;
  }
  .calendar-filters .filters-container .filter-buttons .filter-item .filter-dropdown,
  .calendar-filters .filters-container .filter-buttons .filter-item .adaptive-select-trigger.is-filter {
    width: 173.5px;
    max-width: 173.5px;
    min-width: 173.5px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
